import {HTTP_METHODS} from '@/utils/constants/httpMethods'
import {toSafePathSegment, toSafeQueryString} from '@/utils/security/pathSafety'

export const PROMOTION_PRODUCT_SELECTION_CONFIG = {
  PRODUCT_DROPDOWN_LIST: (dropDownType = '') => {
    const rawDropDownType = String(dropDownType ?? '').trim()
    const safeDropDownType = rawDropDownType ? toSafePathSegment(rawDropDownType) : ''

    return {
      endPoint: `dropdowns/${safeDropDownType}`,
      method: HTTP_METHODS.GET,
      baseUrlKey: 'inventoryApiUrl',
    }
  },
  GTIN_ALL: (queryParams = {}) => {
    const queryString = toSafeQueryString(queryParams)

    return {
      endPoint: `gtin${queryString ? `?${queryString}` : '?'}`,
      method: HTTP_METHODS.GET,
      baseUrlKey: 'inventoryApiUrl',
    }
  },
  GTIN_DETAILS: (gtinId = '', queryParams = {}) => {
    const queryString = toSafeQueryString(queryParams)
    const rawGtinId = String(gtinId ?? '').trim()
    const safeGtinId = rawGtinId ? toSafePathSegment(rawGtinId) : ''

    return {
      endPoint: `gtin/${safeGtinId}${queryString ? `?${queryString}` : '?'}`,
      method: HTTP_METHODS.GET,
      baseUrlKey: 'inventoryApiUrl',
    }
  },
}
